import * as dateUtil from './datetime';
import * as numberUtil from './numberUtil';
import * as tools from './tools';
import * as objUtils from './objUtils';
import * as serviceUtil from './serviceUtil'; 
import * as strUtil from './strUtil';
import * as ukeyUtil from './ukeyUtil';

export default { serviceUtil, strUtil, 
  dateUtil,
  numberUtil,
  tools, objUtils, ukeyUtil, 
}


// WEBPACK FOOTER //
// ./src/utils/util.js